import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Table } from '@octano/global-ui';

import { TranslationsKeys } from '../../../../locales/translations';
import { HomologationRequestListItem } from '../types';
import useColumns from '../hooks/useColumns';
import { useHomologationDataLoader } from './HomologationDataLoader';

export default function HomologationTable() {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION);
  const { data, updateQuery, query } = useHomologationDataLoader();
  const history = useHistory();

  const onViewDetail = useCallback(
    (row: HomologationRequestListItem) => {
      history.push(`/homologation-requests/${row.responseId}`);
    },
    [history],
  );

  const columns = useColumns({ onViewDetail });

  return (
    <Table
      data={data?.data ?? []}
      columns={columns}
      noResultsText={
        <p className="text-muted text-center py-4">{t('table.noResults')}</p>
      }
      pagination={{
        totalItems: data?.total ?? 0,
        onChangePage: (page) => updateQuery((prev) => ({ ...prev, page })),
        itemsPerPage: 10,
        totalPages: data?.total_pages ?? 0,
        currentPage: query.page,
      }}
    />
  );
}
